import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, ButtonBase } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../theme/tokens';
import { isActivePath, mainNav, NavItem } from './navItems';

export const BOTTOM_NAV_HEIGHT = 76;

const Tab: React.FC<{ item: NavItem; active: boolean; label: string }> = ({ item, active, label }) => (
  <Box
    component={RouterLink}
    to={item.path}
    aria-current={active ? 'page' : undefined}
    sx={{
      minHeight: 52,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.4,
      textDecoration: 'none',
      fontSize: 11.5,
      fontWeight: active ? 700 : 600,
      color: active ? tokens.accent : tokens.ink3,
      '& svg': { fontSize: 24 },
    }}
  >
    {item.icon}
    {label}
  </Box>
);

/**
 * The phone's navigation: Início and Lançamentos, the "+" in the middle,
 * then Grupos and Planejamento. Settings live behind the avatar at the top.
 */
const BottomNav: React.FC<{ onRegister: () => void }> = ({ onRegister }) => {
  const { t } = useTranslation('navigation');
  const { pathname } = useLocation();
  const [home, transactions, planning, groups] = mainNav;
  const tab = (item: NavItem) => (
    <Tab key={item.key} item={item} active={isActivePath(pathname, item.path)} label={t(`menu.${item.key}`)} />
  );

  return (
    <Box
      component='nav'
      aria-label={t('shell.navigation')}
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        alignItems: 'end',
        px: 1,
        pt: 1,
        pb: 'calc(10px + env(safe-area-inset-bottom))',
        bgcolor: tokens.surface,
        borderTop: `1px solid ${tokens.line}`,
      }}
    >
      {tab(home)}
      {tab(transactions)}
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <ButtonBase
          onClick={onRegister}
          aria-label={t('shell.register')}
          aria-haspopup='dialog'
          sx={{
            width: 58,
            height: 58,
            mt: '-26px',
            borderRadius: '50%',
            border: `4px solid ${tokens.surface}`,
            bgcolor: tokens.accent,
            color: '#FFFFFF',
            boxShadow: '0 8px 20px -8px rgba(15,118,110,.6)',
          }}
        >
          <AddIcon sx={{ fontSize: 28 }} />
        </ButtonBase>
      </Box>
      {tab(groups)}
      {tab(planning)}
    </Box>
  );
};

export default BottomNav;
